<template>
  <div class="root">
    <div class="content">
      <div class="inner-content">
        <div class="titleTag">FLORENGE</div>
        <div class="title">BLOOM</div>
        <div class="subtitle">in every moment</div>
        <div class="description">
          {{
            `5 thiết kế, 5 bông hoa nở rộ mọi lúc nhắc nhở bạn rằng không cần phải đợi chờ tới những cột mốc quan trọng trong đời để tỏa sáng xinh đẹp hay hạnh phúc, bởi vì trong mọi khoảnh khắc, với Florenge, bạn luôn có thể toả sáng.`
          }}
        </div>
      </div>
      <div class="images-container">
        <div class="image1-wrapper">
          <img src="@/assets/fold2/1.jpg" class="image1" alt="style 1" />
        </div>
        <div class="image2-wrapper">
          <img src="@/assets/fold2/2.jpg" class="image2" alt="style 2" />
        </div>
        <div class="image3-wrapper">
          <img
            src="@/assets/fold2/flower.png"
            class="image3flower"
            alt="style 3 decoration"
          />
          <img src="@/assets/fold2/3.jpg" class="image3" alt="style 3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fold2",
};
</script>
<style lang="scss" scoped>
.root {
  /* background: #000000; */
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    padding-top: 14px;
    padding-bottom: 14px;
    text-align: center;
  }
  .content {
    overflow: hidden;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
    color: #ffffff;
    text-align: center;
    /* padding: 16px; */
    margin-top: 80px;
    .inner-content {
      display: flex;
      flex-direction: column;
      .titleTag {
        font-weight: 300;
        text-align: center;
        color: #000000;
        font-family: "SVN-Gotham", sans-serif;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 1em;
        margin-bottom: 16px;
      }
      .title {
        color: #d35c34;
        font-size: 48px;
        line-height: 54px;
        font-family: "Rollgates Fabulous", sans-serif;
        font-style: italic;
      }
      .subtitle {
        color: #d35c34;
        font-size: 24px;
        line-height: 30px;
        font-family: "Rollgates Fabulous", sans-serif;
        margin-bottom: 32px;
      }
      .description {
        font-family: "SVN-Gotham", sans-serif;

        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 26px;
        /* or 200% */

        text-align: justify;

        color: rgba(0, 0, 0, 0.6);
        padding: 16px;
      }
      .cta-btn {
        background: #ffffff;
        font-family: "SVN-Gotham", sans-serif;
        font-size: 16px;
        line-height: 16px;
        font-weight: 500;
        padding: 16px 72px;
        border: none;
        margin-bottom: 60px;
      }
    }
    .images-container {
      position: relative;
      width: 100%;
      min-height: 170vw;
      .image1-wrapper {
        position: absolute;
        left: 16px;
        margin-top: 50%;
        transform: translateY(-50%);
        z-index: 5;
        .image1 {
          width: 230px;
          height: 295px;
          object-fit: cover;
        }
      }
      .image2-wrapper {
        position: absolute;
        right: 16px;
        margin-top: 65%;
        transform: translateY(-20%);
        z-index: 3;
        .image2 {
          width: 130px;
          height: 190px;
          object-fit: cover;
        }
      }
      .image3-wrapper {
        position: absolute;
        bottom: 16px;
        transform: translateX(50%);
        z-index: 4;
        .image3flower {
          width: 180px;
          height: 180px;
          object-fit: contain;
          position: absolute;
          bottom: 0;
          left: 80px;
        }
        .image3 {
          width: 160px;
          height: 200px;
          object-fit: cover;
        }
      }
    }
  }
}
@media (min-width: 1024px) {
  .root {
    .content {
      margin-top: 0;
      flex-direction: row;
      justify-content: center;
      .inner-content {
        position: absolute;
        padding-top: 15%;
        transform: translateX(35%);
        .titleTag {
          text-align: left;
          font-size: 20px;
          line-height: 20px;
        }
        .title {
          text-align: left;
          font-size: 64px;
          line-height: 76px;
        }
        .subtitle {
          text-align: left;
          font-size: 48px;
          line-height: 54px;
          margin-bottom: 48px;
          color: #000000;
        }
        .description {
          text-align: left;
          max-width: 40%;
          font-size: 16px;
          padding: 0;
        }
      }
      .images-container {
        min-height: max(1000px, 50vw);
        .image1-wrapper {
          position: absolute;
          left: 5%;
          margin-top: 7%;
          transform: none;
          max-width: 27%;
          z-index: 5;
          .image1 {
            max-width: 100%;
            width: 460px;
            height: 590px;
            object-fit: contain;
          }
        }
        .image2-wrapper {
          position: absolute;
          right: 2%;
          margin-top: 30%;
          transform: 0;
          z-index: 4;
          .image2 {
            width: 260px;
            height: 380px;
            object-fit: cover;
          }
        }
        .image3-wrapper {
          position: absolute;
          bottom: 2%;
          transform: translateX(-50%);
          left: 50%;
          z-index: 3;
          .image3flower {
            width: 300px;
            height: 300px;
            object-fit: contain;
            position: absolute;
            bottom: 0;
            left: 128px;
          }
          .image3 {
            width: 260px;
            height: 320px;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>
